export const CAROUSEL_BREAKPOINT = 768;
export const DRAG_THRESHOLD = 5;
export const DRAG_MULTIPLIER = 1.5;
export const INTERSECTION_THRESHOLD = 0.6;
export const KEY_REPEAT_THROTTLE_MS = 50;
